import { TESTOSTERONE_STEP_TYPES } from "@/shared/domains";
import { DocumentAddIcon, TestTubeIcon, VideoCameraIcon } from "@/shared/ui";

export const TESTOSTERONE_STEP_ICONS = {
  [TESTOSTERONE_STEP_TYPES.FORM]: DocumentAddIcon,
  [TESTOSTERONE_STEP_TYPES.INTAKE_FORM]: DocumentAddIcon,
  [TESTOSTERONE_STEP_TYPES.BIOMARKERS_TEST]: TestTubeIcon,
  [TESTOSTERONE_STEP_TYPES.PROVIDER_CONSULTATION]: VideoCameraIcon,
} as const;
